<footer class="site-footer" role="contentinfo">
  <nav class="nav--social-links" aria-label="Social media">
    <ul class="list list--inline">
      <li class="list__item">
        <a
          class="list__link"
          href="https://en-gb.facebook.com/lincolnshirecc/"
          title="Follow us on Facebook"
          target="_blank"
          rel="noopener noreferrer"
        >
          <fa-icon [icon]="faFacebookF"></fa-icon>
          <span class="visually-hidden"
            >Follow us on Facebook (opens in a new tab)</span
          >
        </a>
      </li>
      <li class="list__item">
        <a
          class="list__link"
          href="https://twitter.com/lincolnshirecc?lang=en"
          title="Follow us on X"
          target="_blank"
          rel="noopener noreferrer"
        >
          <fa-icon [icon]="faX"></fa-icon>
          <span class="visually-hidden"
            >Follow us on X (opens in a new tab)</span
          >
        </a>
      </li>
      <li class="list__item">
        <a
          class="list__link"
          href="https://www.linkedin.com/company/lincolnshire-county-council"
          title="Follow us on Linked In"
          target="_blank"
          rel="noopener noreferrer"
        >
          <fa-icon [icon]="faLinkedinIn"></fa-icon>
          <span class="visually-hidden"
            >Follow us on Linked In (opens in a new tab)</span
          >
        </a>
      </li>
      <li class="list__item">
        <a
          class="list__link"
          href="https://www.instagram.com/lincolnshirecc"
          title="Follow us on Instagram"
          target="_blank"
          rel="noopener noreferrer"
        >
          <fa-icon [icon]="faInstagram"></fa-icon>
          <span class="visually-hidden"
            >Follow us on Instagram (opens in a new tab)</span
          >
        </a>
      </li>
    </ul>
  </nav>

  <div class="container">
    <nav class="site-footer__links-main" aria-label="Footer">
      <ul class="list site-footer__list list--inline">
        <li class="list__item">
          <a class="list__link" href="https://www.lincolnshire.gov.uk/privacy"
            >Privacy</a
          >
        </li>
        <li class="list__item">
          <a class="list__link" href="https://www.lincolnshire.gov.uk/cookies"
            >Cookies</a
          >
        </li>
        <li class="list__item">
          <a
            class="list__link"
            href="https://www.lincolnshire.gov.uk/accessibility"
            >Accessibility</a
          >
        </li>
        <li class="list__item">
          <a
            class="list__link"
            href="https://www.lincolnshire.gov.uk/comments-feedback/contact-us"
            >Contact us</a
          >
        </li>
        <li class="list__item">
          <a
            class="list__link"
            href="https://www.lincolnshire.gov.uk/modernslavery"
            >Modern slavery</a
          >
        </li>
      </ul>
    </nav>

    <div class="identity">
      <a
        href="https://www.lincolnshire.gov.uk"
        class="identity__link"
        title="Lincolnshire County Council Home Page"
      >
        <img
          src="assets/images/LCC-Logo-Dark.svg"
          class="identity__logo"
          alt="Logo: Lincolnshire County Council"
        />
      </a>
    </div>
  </div>

  <div class="site-footer__rights-container">
    <div class="container">
      <p class="site-footer__text site-footer__rights">
        All content &copy; {{ year }} Lincolnshire County Council. All Rights
        Reserved.
      </p>
    </div>
  </div>
</footer>
